<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray">
		<TopAppBarLearnListTab :title="$t('66')"></TopAppBarLearnListTab>
			<!-- 상단 고정 캠페인 배너 -->
		<div class="container container--narrow">
			<div class="mgt-30 mgb-50">
				<div v-if="isSearchOpen">
					<Search />
				</div>
				<div v-else>
					<div v-if="campaignData && campaignData.locationValue === '0'" class="mgb-30">
						<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" class="d-block" target="_blank" >
							<img :alt="campaignData.dynamicLink.name" :src="campaignData.image" class="b-radius4">
						</a>
						<a v-else href="javascript:void(0)" style="cursor:none">
							<img :src="campaignData.image" alt="" class="b-radius4">
						</a>
					</div>

					<!-- Category List -->
					<CategoryList />
					
					<!-- Sort options -->
					<listSortOption
						class="pdr-8 pdb-16 d-flex justify-content-end"
						:sortOptions="sortOptions"
						@searchSort="searchSort"
					/>

					<NoData  v-if="isNoData"></NoData>

					<div>
						<div v-for="(degree, index) in listData" :key="index">
							<!-- 목록 캠페인 카드 -->
							<div v-if="campaignData && parseInt(campaignData.locationValue) === index+1 && $route.query.status !== 'WAITING'" class="mgb-16">
								<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" class="d-block" target="_blank">
									<img :src="campaignData.image" class="round">
								</a>
								<a v-else href="javascript:void(0)" style="cursor:none">
									<img :src="campaignData.image" alt="" class="round">
								</a>
							</div>
							<ListItem
								:degree="degree"
								:status="status"
								@initProgressStatus="initProgressStatus"
							/>
						</div>
						<paginate
							v-if="!isNoData"
							v-model="currentPage"
							:click-handler="handlePage"
							:container-class="'pagination'"
							:next-text="'<span class=material-icons >keyboard_arrow_right'"
							:page-class="'pagination-item'"
							:page-count="totalPages"
							:page-range="5"
							:prev-text="'<span class=material-icons >keyboard_arrow_left'">
						</paginate>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

import learnApi from '@/api/learnApi.js';
import campaignApi from '@/api/campaignApi.js';

import { getSortOptions } from "@/utils/sortOptionsUtil";

export default {
	components: {
		InfiniteLoading,
		ListItem: () => import("./ListItem.vue"),
		NoData: () => import("../common/NoDataLearning.vue"),
		TopAppBarLearnListTab: () => import("../TopAppBarLearnListTab.vue"),
		Search: () => import("./list/Search"),
		listSortOption: () => import("@/components/common/RightListSortOptions.vue"),
		CategoryList: () => import("./list/CategoryList.vue"),
	},

	data() {
		return {
			status: '',
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			msgData:{
				msg1:this.$t('3206'),
				msg2:this.$t('3207')
			},
			sortOptions: getSortOptions(this.$route.query.status),
	  		sortOption: getSortOptions(this.$route.query.status)[0].sortValue,
		}
	},

	computed: {
		...mapState({
			isSearchOpen: (state) => state.learn.isSearchOpen,
			categoryState: (state) => state.learn.categoryState,
		}),
	},

	watch:{
		'$route' (to, from){
			this.initData();
	  		this.searchSort(getSortOptions(this.$route.query.status)[0].sortValue);
		},
		sortOption() {
			this.initData();
			this.fetchData();
		},
		categoryState() {
			this.initData();
			this.searchSort(getSortOptions(this.$route.query.status)[0].sortValue);
			this.fetchData();
		},
	},


	mounted() {
		// 기본 파라미터 설정(set default parameter)
		if (!this.$route.query.status) {
			this.$router.push({query: {status: 'LEARNING'}})
		}

		this.fetchData();
	},

	methods: {

		initData() {
			this.listData= []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},
		// 목록 데이터 로딩(get list data)
		async fetchData() {
			const params = this.setParams()
			const learnListResult = await learnApi.fetchList(params);
			const responseData = learnListResult.data.data;
			this.listData = responseData.content.map(val => {
				val.progressViewStatus = false;
				return val;
			});
			this.totalPages = responseData.totalPages
			if (this.listData.length > 0) {
				this.isNoData = false
			} else {
				this.isNoData = true
			}
			this.getCampaignData();
		},

		getCampaignData() {
			// 캠페인 테이터 API 호출(get campaign data)
			let locationType = this.$route.query.status === 'LEARNING' ? 'LEARN_IN_PROGRESS_DEGREE' : this.$route.query.status === 'COMPLETION'?'LEARN_COMPLETED_DEGREE':''
			if(this.$route.query.status === 'LEARNING' || this.$route.query.status === 'COMPLETION') {
				campaignApi.campaign({locationType: locationType}).then((response) => {
					this.campaignData = response.data.data
				}).catch((err) => {})
			} else {
				this.campaignData=''
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				status: this.$route.query.status,
				search: '',
				categories: this.categoryState ? this.categoryState.value : "",
				page: this.currentPage,
				size: 10,
				sort: this.sortOption,
			}
			return params
		},

		// 학습진행률 노출 상태 설정(set/toggle learning status graph)
		initProgressStatus(id) {
			_.map(this.listData, (o) => {
				o.id === id && o.progressViewStatus === false ? o.progressViewStatus = true : o.progressViewStatus = false
			})
		},

		searchSort(value) {
			this.sortOptions.map((sort) => {
				sort.isShow = sort.sortValue === value;
			});
			this.sortOption = value;
		},

		handlePage(page) {
			this.currentPage = page;
			this.fetchData();
		}
	}
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 24px
}
</style>
